import {StoreBase} from "shared/core/Store/StoreBase";

export class SettingsOptions extends StoreBase{
    public LicenseKey:string;

    protected LoadDefaultValues() {
        this.LicenseKey='';
    }

}